export default {
  sampleData(currentState, value) {
    const state = currentState;
    state.sampleData = { ...value };
  },
};
